/**
 * @Author:
 * @Description:
 * @DateTime: Created in 08:56 2019-07-10
 */

import Api from '../../../../util/api';
import {PageDo, Result, ResultPageDo } from '../../../../types/base';
import { defaultNullValue } from 'src/config';

export declare namespace AlarmSearchDOI {
    export interface RowDataI {
        city_id: number;
        city_name: string
        comment: string
        create_time: string
        device_id: number;
        device_name: string
        district_id: number;
        district_name: string
        id: number;
        province_id: number;
        province_name: string
        remarks: string
        status: number;
        type: string
    }

    export interface QueryRowDataParamsI extends PageDo {
        // 省
        province_id?: number;
        // 市
        city_id?: number;
        // 区
        district_id?: number;
        // 通知状态
        infrom_status?: number;
        // 报警类型
        type?: number;
        // 站点类型
        site_type?: number;
        // 站点名称
        device_name?: string;
        control_hierarchy?: number;
        communication_status?: number;
        site_status?: number;
        // 
        types ?: number;
    }
}
export default class AlarmSearchApi {
    /**
     * 查询列表
     * @param {GetPeopleManageListParamsI} params
     * @returns {Promise<ResultPageDo<PeopleManageRowI[]>>}
     */
    static async searchList(params: AlarmSearchDOI.QueryRowDataParamsI): Promise<ResultPageDo<AlarmSearchDOI.RowDataI[]>> {
        return Api.post('/monitor/alarm/query', {
            province_id: defaultNullValue,
            city_id: defaultNullValue,
            district_id: defaultNullValue,
            infrom_status: defaultNullValue,
            type: defaultNullValue,
            device_name: '',
            start_time: '',
            end_time: '',
            ...params,
        });
    }

    static async notice(params: {mobiles:Array<string>, inform_content: string}): Promise<Result<any>> {
        return Api.post('/monitor/inform/alarm',params);
    }
}
